import { type ReactNode } from 'react';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: ReactNode;
  title?: string;
  actions?: ReactNode;
}

export function Layout({ children, title, actions }: LayoutProps) {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 min-w-0 overflow-x-hidden overflow-y-auto">
        {(title || actions) && (
          <header className="sticky top-0 z-10 flex items-center justify-between border-b border-border bg-bg-primary/95 px-8 py-4 backdrop-blur">
            <h1 className="text-xl font-semibold text-text-primary">{title}</h1>
            <div className="flex items-center gap-2">{actions}</div>
          </header>
        )}
        <div className="p-4">{children}</div>
      </main>
    </div>
  );
}
